import { useRef, useState } from "react";
import InputCom from "../../Helpers/InputCom";
import "../Dashboard.css";

export default function ProfileTab({ myProfile }) {
  const [profileImg, setprofileImg] = useState(null);
  const profileImgInput = useRef(null);
  const browseprofileImg = () => {
    profileImgInput.current.click();
  };
  const profileImgChangHandler = (e) => {
    if (e.target.value !== "") {
      const imgReader = new FileReader();
      imgReader.onload = (event) => {
        setprofileImg(event.target.result);
      };
      imgReader.readAsDataURL(e.target.files[0]);
    }
  };

  console.log("myProfile : ", myProfile);
  return (
    <>
      <div
        className="profile-title"
        style={{
          fontSize: "24px",
          fontWeight: 600,
          color: "#333",
          marginBottom: "20px",
          textAlign: "left",
        }}
      >
        Profile
      </div>
      <div className="profile-tab-container">
        <div className="form-row">
          <label>Company Name</label>
          <input
            type="text"
            value={myProfile.companyName || ""}
            placeholder="Company Name"
          />
        </div>

        <div className="form-row">
          <label>Username</label>
          <input
            type="text"
            value={myProfile.loginId || ""}
            readOnly
            placeholder="Username"
          />

          <label>Account Number</label>
          <input
            type="text"
            value={myProfile.accountNumber || ""}
            placeholder="Account Number"
          />
        </div>

        <div className="form-row">
          <label>Email</label>
          <input
            type="email"
            value={myProfile.contactEmail || ""}
            placeholder="Email"
          />
        </div>

        <div className="form-row">
          <label>Phone Number</label>
          <input
            type="text"
            value={myProfile.contactPhone || ""}
            placeholder="Phone Number"
          />
        </div>

        <div className="form-row">
          <label>Shipping Address</label>
          <textarea
            value={`${myProfile.shipToAddress1 || ""}, ${
              myProfile.shipToCity || ""
            }, ${myProfile.shipToState || ""}, ${
              myProfile.shipToCountry || ""
            }, ${myProfile.shipToZipCode || ""}`}
            placeholder="Shipping Address"
          />
        </div>

        <div className="form-row">
          <label>Billing Address</label>
          <textarea
            value={`${myProfile.billToAddress1 || ""}, ${
              myProfile.billToCity || ""
            }, ${myProfile.billToState || ""}, ${
              myProfile.billToCountry || ""
            }, ${myProfile.billToZipCode || ""}`}
            placeholder="Billing Address"
          />
        </div>
      </div>
    </>

    /*
<>
<div className="flex space-x-8">
  <div className="w-[570px] ">
    <div className="input-item flex space-x-2.5 mb-8">
      <div className="half-width h-full">
        <InputCom
          label="Username"
          value={myProfile.loginId || ""}
          type="text"
          inputClasses="h-[50px]"
          readOnly
        />
      </div>
    </div>
    <div className="input-item flex space-x-2.5 mb-8">
      <div className="half-width h-full">
        <InputCom
          label="Company Name"
          value={myProfile.companyName || ""}
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
      <div className="half-width h-full">
        <InputCom
          label="Account Number"
          value={myProfile.accountNumber || ""}
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
    </div>
    <div className="input-item flex space-x-2.5 mb-8">
      <div className="half-width h-full">
        <InputCom
          label="Email"
          value={myProfile.contactEmail || ""}
          type="email"
          inputClasses="h-[50px]"
        />
      </div>
      <div className="half-width h-full">
        <InputCom
          label="Phone Number"
          value={myProfile.contactPhone || ""}
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
    </div>
     
    <div className="input-item mb-8">
      <div className="w-full">
        <InputCom
          label="Country*"
          placeholder="country"
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
    </div>
    <div className="input-item mb-8">
      <div className="w-full">
        <InputCom
          label="Address*"
          placeholder="your address here"
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
    </div>
    <div className="input-item flex space-x-2.5 mb-8">
      <div className="w-1/2 h-full">
        <InputCom
          label="Town / City*"
          placeholder=""
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
      <div className="w-1/2 h-full">
        <InputCom
          label="Postcode / ZIP*"
          placeholder=""
          type="text"
          inputClasses="h-[50px]"
        />
      </div> 
    </div>
    
  </div>
  
  <div className="flex-1">
    <div className="update-logo w-full mb-9">
      <h1 className="text-xl tracking-wide font-bold text-qblack flex items-center mb-2">
        Update Profile
        <span className="ml-1">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 0C4.47457 0 0 4.47791 0 10C0 15.5221 4.47791 20 10 20C15.5221 20 20 15.5221 20 10C19.9967 4.48126 15.5221 0.00669344 10 0ZM10 16.67C9.53815 16.67 9.16667 16.2985 9.16667 15.8367C9.16667 15.3748 9.53815 15.0033 10 15.0033C10.4618 15.0033 10.8333 15.3748 10.8333 15.8367C10.8333 16.2952 10.4618 16.67 10 16.67ZM11.6098 10.425C11.1078 10.7396 10.8132 11.2952 10.8333 11.8842V12.5033C10.8333 12.9652 10.4618 13.3367 10 13.3367C9.53815 13.3367 9.16667 12.9652 9.16667 12.5033V11.8842C9.14324 10.6861 9.76907 9.56827 10.8032 8.96586C11.4357 8.61781 11.7704 7.90161 11.6366 7.19545C11.5027 6.52276 10.9772 5.99732 10.3046 5.8668C9.40094 5.69946 8.5308 6.29853 8.36346 7.20214C8.34673 7.30254 8.33668 7.40295 8.33668 7.50335C8.33668 7.96519 7.9652 8.33668 7.50335 8.33668C7.0415 8.33668 6.67002 7.96519 6.67002 7.50335C6.67002 5.66265 8.16265 4.17001 10.0067 4.17001C11.8474 4.17001 13.34 5.66265 13.34 7.50669C13.3333 8.71821 12.674 9.83601 11.6098 10.425Z"
              fill="#374557"
              fillOpacity="0.6"
            />
          </svg>
        </span>
      </h1>
      <p className="text-sm text-qgraytwo mb-5 ">
        Profile of at least Size
        <span className="ml-1 text-qblack">300x300</span>. Gifs work too.
        <span className="ml-1 text-qblack">Max 5mb</span>.
      </p>
      <div className="flex xl:justify-center justify-start">
        <div className="relative">
          <div className="sm:w-[198px] sm:h-[198px] w-[199px] h-[199px] rounded-full overflow-hidden relative">
            <img
              src={
                profileImg ||
                `${process.env.PUBLIC_URL}/assets/images/edit-profileimg.jpg`
              }
              alt=""
              className="object-cover w-full h-full"
            />
          </div>
          <input
            ref={profileImgInput}
            onChange={(e) => profileImgChangHandler(e)}
            type="file"
            className="hidden"
          />
          <div
            onClick={browseprofileImg}
            className="w-[32px] h-[32px] absolute bottom-7 sm:right-0 right-[105px]  bg-qblack rounded-full cursor-pointer"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5147 11.5C17.7284 12.7137 18.9234 13.9087 20.1296 15.115C19.9798 15.2611 19.8187 15.4109 19.6651 15.5683C17.4699 17.7635 15.271 19.9587 13.0758 22.1539C12.9334 22.2962 12.7948 22.4386 12.6524 22.5735C12.6187 22.6034 12.5663 22.6296 12.5213 22.6296C11.3788 22.6334 10.2362 22.6297 9.09365 22.6334C9.01498 22.6334 9 22.6034 9 22.536C9 21.4009 9 20.2621 9.00375 19.1271C9.00375 19.0746 9.02997 19.0109 9.06368 18.9772C10.4123 17.6249 11.7609 16.2763 13.1095 14.9277C14.2295 13.8076 15.3459 12.6913 16.466 11.5712C16.4884 11.5487 16.4997 11.5187 16.5147 11.5Z"
                fill="white"
              />
              <path
                d="M20.9499 14.2904C19.7436 13.0842 18.5449 11.8854 17.3499 10.6904C17.5634 10.4694 17.7844 10.2446 18.0054 10.0199C18.2639 9.76139 18.5261 9.50291 18.7884 9.24443C19.118 8.91852 19.5713 8.91852 19.8972 9.24443C20.7251 10.0611 21.5492 10.8815 22.3771 11.6981C22.6993 12.0165 22.7105 12.4698 22.3996 12.792C21.9238 13.2865 21.4443 13.7772 20.9686 14.2717C20.9648 14.2792 20.9536 14.2867 20.9499 14.2904Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>

<div className="w-[570px] ">
  <div className="input-item flex space-x-2.5 mb-8">
    <div className="w-full h-full">
      <InputCom
        label="Shipping address"
        value={`${myProfile.shipToAddress1 || ""}, ${
          myProfile.shipToCity || ""
        }, ${myProfile.shipToState || ""}, ${
          myProfile.shipToCountry || ""
        }, ${myProfile.shipToZipCode || ""}`}
        type="text"
        inputClasses="h-[50px]"
      />
    </div>
  </div>

  {myProfile.shipToAddress2 && (
    <div className="input-item flex space-x-2.5 mb-8">
      <div className="w-full h-full">
        <InputCom
          label="Shipping Address 2"
          value={myProfile.shipToAddress2}
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
    </div>
  )}

  <div className="input-item flex space-x-2.5 mb-8">
    <div className="w-full h-full">
      <InputCom
        label="Billing Address"
        value={`${myProfile.billToAddress1 || ""}, ${
          myProfile.billToCity || ""
        }, ${myProfile.billToState || ""}, ${
          myProfile.billToCountry || ""
        }, ${myProfile.billToZipCode || ""}`}
        type="text"
        inputClasses="h-[50px]"
      />
    </div>
  </div>

  {myProfile.billToAddress2 && (
    <div className="input-item flex space-x-2.5 mb-8">
      <div className="w-full h-full">
        <InputCom
          label="Billing Address 2"
          value={myProfile.billToAddress2}
          type="text"
          inputClasses="h-[50px]"
        />
      </div>
    </div>
  )}
</div>
 
<div className="action-area flex space-x-4 items-center">
  <button type="button" className="text-sm text-qred font-semibold">
    Cancel
  </button>
  <button
    type="button"
    className="w-[164px] h-[50px] bg-qblack text-white text-sm"
  >
    Update Profile
  </button>
</div>

</>
  */
  );
}
